import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
	header: {
		textAlign: 'center',
		padding: '8px 10px',
		fontSize: '26px',
		lineHeight: '39px',
		fontWeight: 700,
		color: '#595959',
	},
	title: {
		textAlign: 'center',
		fontSize: '14px',
		marginTop: '20px',
	},
};

class DuplicatesTemplate extends Component {
	render() {
		const {
			duplicates,
			isInCurrentCallCenter,
			classes,
		} = this.props;

		const sortedDuplicates = duplicates.sort((a, b) => {
			return a.callCenterName > b.callCenterName
				? 1
				: a.callCenterName < b.callCenterName
					? -1
					: 0;
		})

		return (
			<div>
				<div className={classes.header}>
					Notice
				</div>
				{
					isInCurrentCallCenter &&
					<div className={classes.title}>
						This phone number is not added as it is already exist in the current Contact Center
					</div>
				}
				{
					!isInCurrentCallCenter &&
					<div>
						<div className={classes.title}>
							Failed to add the following phone number(s) as the record(s) already exist in another Contact Center:
					</div>
						<ul>
							{sortedDuplicates.map(({ phoneNumber, callCenterName }, index) => (
								<li key={index}>
									<b>{phoneNumber}</b> – {callCenterName}
								</li>
							))}
						</ul>
					</div>
				}
			</div>
		);
	}
}

export default withStyles(styles)(DuplicatesTemplate);
